export const CURRENT_MODEL_VERSION = '1.5.0';

// Generated by `npm run model:versions:generate` from the files in public/models/model_*.json. Do not edit by hand.
export const ARCHIVED_MODEL_VERSIONS = ['1.4.0', '1.3.2', '1.3.1', '1.3.0', '1.2.0', '1.1.0', '1.0.1'] as const;

export const MODEL_VERSIONS = [CURRENT_MODEL_VERSION, ...ARCHIVED_MODEL_VERSIONS] as const;
export type ModelVersion = (typeof MODEL_VERSIONS)[number];

const MODEL_VERSIONS_SET = new Set<string>(MODEL_VERSIONS);
export const isModelVersion = (version: string): version is ModelVersion => MODEL_VERSIONS_SET.has(version);
